module.exports = __webpack_public_path__ + "91a7b47545786b486f42fd6908b29f55.svg";